import React, { useState } from 'react';
import { X } from 'lucide-react';
import { Card } from '../components/ui/card';

export const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);

  // All images from the public folder
  const galleryImages = [
    { id: 1, url: '/1.webp', title: 'Ambulance Service' },
    { id: 2, url: '/2.webp', title: 'Emergency Medical Vehicle' },
    { id: 3, url: '/3.webp', title: 'Medical Transport' },
    { id: 4, url: '/4.webp', title: 'Emergency Response Unit' },
    { id: 5, url: '/5.webp', title: 'Ambulance Fleet' },
    { id: 6, url: '/6.webp', title: 'Medical Equipment' },
    { id: 7, url: '/7.webp', title: 'Emergency Services' },
    { id: 8, url: '/8.webp', title: 'Life Support Ambulance' },
    { id: 9, url: '/9.webp', title: 'Critical Care Transport' },
    { id: 10, url: '/10.webp', title: 'Medical Response Vehicle' },
    { id: 11, url: '/11.webp', title: 'Emergency Ambulance' },
    { id: 12, url: '/12.webp', title: 'Healthcare Transport' },
    { id: 13, url: '/13.webp', title: 'Advanced Life Support' },
    { id: 14, url: '/14.jpeg', title: 'Medical Services' },
    { id: 15, url: '/15.jpeg', title: 'Emergency Care' },
    { id: 16, url: '/16.jpeg', title: 'Ambulance Interior' },
    { id: 17, url: '/17.jpeg', title: 'Medical Facility' },
    { id: 18, url: '/18.jpeg', title: 'Emergency Response' },
    { id: 19, url: '/19.jpeg', title: 'Patient Transport' },
    { id: 20, url: '/20.jpeg', title: 'Medical Equipment Setup' },
    { id: 21, url: '/21.jpeg', title: 'Emergency Services Team' },
    { id: 22, url: '/22.jpeg', title: 'Healthcare Vehicle' },
    { id: 23, url: '/23.jpeg', title: 'Medical Response' },
    { id: 24, url: '/24.jpeg', title: 'Emergency Transport' },
    { id: 25, url: '/25.jpeg', title: 'Care Ambulance Service' }
  ];

  const openLightbox = (image) => {
    setSelectedImage(image);
    document.body.style.overflow = 'hidden';
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    document.body.style.overflow = 'auto';
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header Section */}
      <section className="bg-red-600 text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Gallery</h1>
          <p className="text-xl text-red-100">
            Our ambulances, equipment, and emergency response services
          </p>
        </div>
      </section>

      {/* Gallery Content */}
      <div className="container mx-auto px-4 py-12">
        {/* Image Grid */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          {galleryImages.map((image) => (
            <Card
              key={image.id}
              className="overflow-hidden cursor-pointer group hover:shadow-2xl transition-all duration-300"
              onClick={() => openLightbox(image)}
            >
              <div className="relative aspect-square overflow-hidden">
                <img
                  src={image.url}
                  alt={image.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
            </Card>
          ))}
        </div>
      </div>

      {/* Lightbox Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 z-50 bg-black bg-opacity-95 flex items-center justify-center p-4"
          onClick={closeLightbox}
        >
          <button
            onClick={closeLightbox}
            className="absolute top-4 right-4 w-12 h-12 bg-white rounded-full flex items-center justify-center hover:bg-gray-200 transition-colors z-10"
            aria-label="Close lightbox"
          >
            <X className="w-6 h-6 text-gray-900" />
          </button>
          <div className="max-w-6xl w-full" onClick={(e) => e.stopPropagation()}>
            <img
              src={selectedImage.url}
              alt={selectedImage.title}
              className="w-full h-auto max-h-[85vh] object-contain rounded-lg shadow-2xl"
            />
          </div>
        </div>
      )}
    </div>
  );
};